.input-text-editable::placeholder{font-size:16px}mat-form-field{min-height:68px}
/*# sourceMappingURL=decimal-number.component-AVXL54TG.css.map */
